import { Col } from 'react-styled-flexboxgrid';
import styled from '@emotion/styled';

import { DESKTOP_START_QUERY } from '../mixins/responsive';
import { pluckPropertyIfExists } from '../../utils/data-transformers/theme';

// layout is used to shim the rest of the content if it isn't a centered piece
export const MediaLayoutContainer = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: inherit;

  ${({ theme }) => {
    return pluckPropertyIfExists(theme, 'Slat.mobile.mediaStyles', 'padding');
  }};

  @media (${DESKTOP_START_QUERY}) {
    ${({ theme }) => {
      return pluckPropertyIfExists(
        theme,
        'Slat.desktop.mediaStyles',
        'padding',
      );
    }};
  }
`;

export default MediaLayoutContainer;
